const choices = {
    withVerdict: 'Fixée par jugement',
    withoutVerdict: 'Absence de jugement',
    sameRoof: 'Vivant sous le même toit',
};

export default choices;
